<div id="board-of-studies" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Board of Studies</h2>
    <p class="inner-lead mt-3">
      The Board of Studies is an academic body constituted for each department/subject. It frames the curriculum,
      recommends books and monitors the academic standards of the college. The Board plays a pivotal role in curriculum
      development and academic policy decisions.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Board of Studies Document</h4>

    <div class="pdf-block">
      <pdf-viewer src="/assets/pdf/admin/BOARD-OF-STUDIES.pdf" [render-text]="true" [original-size]="false"
        style="width:100%; height:680px; display:block;">
      </pdf-viewer>
    </div>

    <div class="mt-3">
      <a href="/assets/pdf/admin/BOARD-OF-STUDIES.pdf" target="_blank" class="pdf-download-btn">
        <i class="fa fa-download"></i> Download Board of Studies Document
      </a>
    </div>

  </div>
</div>